import { TVariant } from 'shared/ui/cards/basicCard';
import { FC } from 'react';
import { PersonData } from 'entities/person';
import { TextCard } from 'shared/ui/cards/textCard';

interface OrderPersonNotesProps {
	person?: PersonData | null;
	variant?: TVariant;
	title?: string;
	outputDashInsteadNotes?: boolean;
	padding?: string;
}

export const OrderPersonNotes: FC<OrderPersonNotesProps> = ({
	person,
	// variant = 'main',
	// title = 'Комментарий из карточки гостя',
	// outputDashInsteadNotes = false,
	padding = '8px 12px',
}) => {
	return (
		<>
			{!person?.notes?.trim?.() ? (
				<></>
			) : (
				<>
          <TextCard fitContent={false} mode='small' padding={padding}>
            {person?.notes}
          </TextCard>
					{/* <InfoFieldCard
						variant={variant}
						title={title}
						styles={{ padding }}
					>
						{person?.notes}
					</InfoFieldCard> */}
				</>
			)}
		</>
	);
};
